/* eslint-disable @typescript-eslint/no-explicit-any */
import { authToken } from 'src/app/auth/cookies';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Const from 'src/config/Const';
import Script from 'next/script';
import decrypt from 'src/utils/cryptography';
import removeUserInfo from 'src/app/auth/removeUserInfo';
import setUserInfo from 'src/app/auth/setUserInfo';

declare global {
  interface Window {
    branch: {
      init: (
        branchKey: string | undefined,
        branchCallback: (err: any, data: any) => void
      ) => void;
    };
  }
}

const loginWithBranchLink = (data: any): void => {
  const urlData = data.referring_link.split('=')[2];
  if (urlData) {
    const decrypted = decrypt(decodeURIComponent(urlData));
    const user = JSON.parse(decrypted);
    if (user.token) {
      if (authToken()) {
        removeUserInfo();
      }
      setUserInfo(user.token as string);
    }
  }
};

const BranchScript = (): JSX.Element => {
  const router = useRouter();

  const handleBranchDeepLinkActions = (action: string, data: any): void => {
    switch (action) {
      case 'mail_reset_password':
        loginWithBranchLink(data);
        router.push('/password/reset/confirm');
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    window.branch.init(Const.branchKey, (err, data) => {
      if (data && data.referring_link) {
        handleBranchDeepLinkActions(data.data_parsed.app_action, data);
      }
      if (err) throw err;
    });
  });

  return (
    /* eslint-disable @next/next/inline-script-id */
    <Script
      dangerouslySetInnerHTML={{
        __html: `(function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);`,
      }}
    />
    /* eslint-enable @next/next/inline-script-id */
  );
};

export default BranchScript;
